export const lightTheme = {
  body: '#F3F4FA',
  body2: 'rgb(253, 253, 253)',
  tradebody: '#ededed',
  text: '#212121',
  toggleBorder: '#FFF',
  background: '#363537',
  box: '#F8F7F8',
  menuTextHover: '#007AFF',
  subMenu: '#F6E8E5',
  subMenuHover: '#F8F7F8',
  subMenuShadow: '5px 6px 9px 3px rgba(106, 106, 106, 0.30)',
  button: '#E5E5E5',
  searchBg: '#FAFAFA',
  searchText: '#000',
  inactive: '#B7B7B7',
  p2pBody: '#FAFAFA',
  p2pBorder: '#DDE0F3',
  primary: '#007AFF',
  second: '#E10FF0',
  subBg: '#FAFAFA',
  footerText: '#666666',
  tabBG: '#ddd',
  itemBg: 'rgb(253, 253, 253)',
  moreText: '#616161',
  cardBg: '#F6EDEA',
  inputPlaceholderText: '#757575',
  border2: '#EFD9D0',
};

export const darkTheme = {
  body: '#080D0C',
  body2: '#080D0C',
  tradebody: '#13191b',
  text: '#fff',
  toggleBorder: '#6B8096',
  background: '#999',
  box: '#232432',
  menuTextHover: '#007AFF',
  subMenu: '#1F1F1F',
  subMenuHover: '#333333',
  subMenuShadow: '5px 6px 9px rgba(0, 0, 0, 0.3)',
  button: '#42434A',
  searchBg: '#282838',
  searchText: '#6B6B70',
  inactive: '#999',
  p2pBody: '#282838',
  p2pBorder: '#333333',
  primary: '#007AFF',
  second: '#E10FF0',
  subBg: '#282838',
  footerText: '#AFAFAF',
  tabBG: '#2f2f40',
  itemBg: '#1F1F1F',
  moreText: '#C8C8D2',
  cardBg: '#1F1F1F',
  inputPlaceholderText: '#B5B5BC',
  border2: '#333333',
};

export const sizes = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1350px',
  desktop2: '1920px',
  max: '1718px',
};

export const media = {
  mobile: `(max-width: ${sizes.mobile})`,
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(max-width: ${sizes.desktop})`,
  desktop2: `(max-width: ${sizes.desktop2})`,
  max: `(max-width: ${sizes.max})`,
};
